__webpack_public_path__ = window.resourceBaseUrl;



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 1134
// module chunks = 5